import { styled } from 'styled-components';

import { colors, cssBreakpoints, spacing, transition } from '#/theme/theme';

const SEARCH_FACET_CHIP_WIDTH = '150px';

export const SearchRefinementDropdownHolder = styled.div`
  cursor: pointer;
  order: 1;

  && menu {
    border-radius: 8px;
    padding: ${spacing[24]};
  }

  &:last-child menu {
    padding: 0 ${spacing[24]};

    details:last-child button {
      margin-bottom: ${spacing[24]};
    }
  }

  /* 
  * Remove these styles when 
  * we replace the legacy job family facet
  */
  &[data-facet-type='synonymId'] span[data-variant='default'] {
    background-color: ${colors.selectionBlue};
    max-width: 165px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /*
  * These should get extracted to some kind of animated pill
  * They are very similar to the children of <CheckboxPills>
  */

  > label:has(> input[type='checkbox']) {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 36px;
    cursor: pointer;
    transition: ${transition};
    transition-property: background-color, color, width;
    user-select: none;
    width: 100%;

    > span {
      gap: 0;
      width: 100%;
    }

    > span > :first-child {
      margin-right: ${spacing[8]};
    }

    > span > :last-child {
      flex: 0;
      justify-content: flex-end;
      opacity: 0;
      overflow: hidden;
      transition: ${transition};
      transition-property: opacity, flex;
      width: 0;
    }

    &:has(input:checked) {
      width: calc(100% + 8px);

      > span,
      > span:hover {
        background: ${colors.selectionBlue};
        color: ${colors.brandBlue};
        gap: inherit;
      }

      > span > :last-child {
        flex: 1;
        opacity: 1;
        width: 100%;
      }
    }
  }

  /* End CheckboxPills */

  &[open],
  &:hover > details > summary > span {
    background-color: ${colors.selectionGrey};
  }

  &[data-facet-state='PINNED'] summary > span,
  &[data-facet-state='QUEUED']:has(input:checked:not([value='']))
    summary
    > span,
  &[data-facet-state='QUEUED']:has(
      input[type='startsLT']:not(
          [value=''],
          input[name='endsGT']:not([value=''])
        )
    )
    summary
    > span {
    background-color: ${colors.selectionBlue};
  }

  &[data-facet-state='PINNED'],
  &[data-facet-state='QUEUED']:not(:has(input:checked:not([value='']))),
  &[data-facet-state='QUEUED']:not(
      :has(
        input[name='startsLT']:not([value='']),
        input[name='endsGT']:not([value=''])
      )
    ) {
    order: 0;
  }

  &:last-child:is(:not(:first-child)):has(
      details > div:not([data-hidden='true']) input:checked:not([value='']),
      details
        > div:not([data-hidden='true'])
        input[name='startsLT']:not([value='']),
      details
        > div:not([data-hidden='true'])
        input[name='endsGT']:not([value=''])
    )
    summary
    > span {
    background-color: ${colors.selectionBlue};
  }

  @media all and (min-width: calc(${cssBreakpoints.mdUp} + ${SEARCH_FACET_CHIP_WIDTH} * 4)) {
    /* Handle hiding the overflow menu if all facets are visible */
    &:last-child:not(:has([data-hidden='false'])) {
      display: none;
    }
  }

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    && menu {
      width: 100%;
      margin-top: 0;
    }
  }
`;

// @NOTE: Will be removed when Job Family facet is modified
export const JobFamilyFacetCloseButton = styled.div`
  color: ${colors.selectionGrey};
  height: 16px;
  width: 16px;
`;
